// extracted by mini-css-extract-plugin
export default {"disclaimer":"Disclaimer_disclaimer__lU1L1","contactInnovationExpertButton":"Disclaimer_contactInnovationExpertButton__QkBE5"};